<template functional>
  <div
    :ref="data.ref"
    :class="$style.wrapper"
    class="animate__animated animate__fadeIn animate__faster stick-all-corners"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <slot />
  </div>
</template>

<script>
import 'animate.css';
export default {};
</script>

<style lang="scss" module>
.wrapper {
  background-color: rgba(black, 0.8);
}
</style>
